var map = {
	"./9815390.png": "c125",
	"./9816334.png": "89e5",
	"./AQ.png": "5531",
	"./EQ.png": "b84e",
	"./M361.png": "8bce",
	"./altraQualita/altraQUALITA.png": "5b06",
	"./arrow.png": "c5d4",
	"./background_altromercato_concorso_24.png": "42d9",
	"./background_altromercato_concorso_24_mobile.png": "7bc8",
	"./banner.png": "ec24",
	"./button1.png": "8974",
	"./button2.png": "59bd",
	"./button3.png": "7aae",
	"./button4.png": "6192",
	"./button5.png": "4c89",
	"./button6.png": "e1fd",
	"./cart-white.png": "615b",
	"./cart.png": "41b9",
	"./casa.png": "02b5",
	"./certificazioni.png": "813b",
	"./certificazioni_wfto_2026.png": "9412",
	"./clickandcollectmarker.png": "7be4",
	"./completa_la_promo.png": "def1",
	"./equomercato/equo.png": "8cb2",
	"./external/negozi.png": "8554",
	"./external/produttori.png": "bdaa",
	"./external/sostenibilita.png": "3d61",
	"./home1.png": "2fce",
	"./home2.png": "517f",
	"./iconeLink/filiera.png": "04a4",
	"./iconeLink/scopri.png": "40ae",
	"./iconeLink/video.png": "95f9",
	"./immagini_zuccheri/demerara.png": "cb35",
	"./immagini_zuccheri/dulcita.png": "0399",
	"./immagini_zuccheri/fior-di-cocco.png": "4986",
	"./immagini_zuccheri/manduvira.png": "9b5a",
	"./immagini_zuccheri/mascobado.png": "7ae9",
	"./immagini_zuccheri/picaflor.png": "7e35",
	"./logo.png": "cf05",
	"./map_produttore.png": "871e",
	"./marker.png": "3b84",
	"./marks/icona1.png": "5abe",
	"./marks/icona1_old.png": "a630",
	"./marks/icona2.png": "f1e9",
	"./marks/icona3.png": "32d0",
	"./marks/icona3_old.png": "c27a",
	"./marks/icona4.png": "09b6",
	"./marks/v.png": "f1fc",
	"./meridiano/meridiano.png": "95d1",
	"./pagamenti.png": "8b8d",
	"./paginaCioccolato/fondente_pack.png": "0da5",
	"./paginaCioccolato/latte_pack.png": "d6f8",
	"./paginaCioccolato/nocciole_pack.png": "ad92",
	"./placeholder-image.png": "d475",
	"./placeholder.png": "5b4d",
	"./prodotto.png": "b71d",
	"./user.png": "c121"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "9e01";